import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from "@angular/router";
import { EssentialService } from "../../services/essential.service";
import { MenuService } from "../../services/menu.service";

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
  // providers:[MenuService]
})
export class MenuComponent implements OnInit {
  @Input() public settings: any;
  @Input() public data: any;

  menuSiblings: any = [];
  allPages: any = [];
  parenMenu: any = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public menuService: MenuService) { }

  menuContentTheme = 'all';

  activeMenu: { parent: number };
  flatMenu: any[] = [];
  public searchText: any;
  public menus: any[] = [];
  public site: any;
  public user: any;
  public activeClass = false;

  ngOnInit() {

    if (this.data.authService && this.data.authService.isLoggedIn()) {
      this.user = this.data.authService.getLoggedUser();
    }

    this.settings.nav_background_color = this.settings.nav_background_color && this.settings.nav_background_color.charAt(0) === '#' ? this.settings.nav_background_color : this.getThemeColor(this.settings.nav_background_color);
    this.settings.nav_text_color = this.settings.nav_text_color && this.settings.nav_text_color.charAt(0) === '#' ? this.settings.nav_text_color : this.getThemeColor(this.settings.nav_text_color);
    this.settings.child_background_color = this.settings.child_background_color && this.settings.child_background_color.charAt(0) === '#' ? this.settings.child_background_color : this.getThemeColor(this.settings.child_background_color);
    this.settings.child_text_color = this.settings.child_text_color && this.settings.child_text_color.charAt(0) === '#' ? this.settings.child_text_color : this.getThemeColor(this.settings.child_text_color);

    this.menuContentTheme = this.settings.menuContentTheme || 'all';
    let slug = this.route.data['value'].data[0].slug;
    this.menuService.getMenu(this.settings.selectedCategory, this.data, slug);

    this.route.paramMap.subscribe(
      route => {
        slug = this.route.data['value'].data[0].slug;
        this.menuService.setActiveLink(this.settings.selectedCategory, slug);
      }
    )
  }

  public getThemeColor(color) {
    if (this.data && this.data.moduleService && this.data.moduleService.theme && this.data.moduleService.theme.colors) {
      return this.data.moduleService.theme.colors[color];
    } else {
      return 'initial';
    }
  }

  public navigateToCulture() {
    let link = ''
    //Customer portal
    let cpProductOutput: any = localStorage.getItem('cpProductOutput')
    if (this.route.data['value'].type == 1)
      link = this.getCultureLinkedPage(this.route.data['value'].id, this.settings.Culture);
    else
      link = this.getCultureLinkedBlog(this.route.data['value'].id, this.settings.Culture);

    if (link != '/' && this.data.moduleService.site.css) {
      let oldCulture = this.data.moduleService.site.culture;
      this.data.moduleService.site.culture = this.settings.Culture;
      this.router.navigate([link]);
      this.setsiteCss(this.settings.Culture,oldCulture);
    } else {
      this.router.navigate([link]);
    }


    if (cpProductOutput) {
      cpProductOutput = JSON.parse(cpProductOutput)
      link = link + `/productpreview?step=${cpProductOutput.step}&userPropertiesId=${cpProductOutput.userPropertiesId}`
      localStorage.removeItem('cpProductOutput')  //cpProductOutput
      this.router.navigate([link]);
    }

  }

  public getCultureLinkedPage(id, culture) {
    const currentPage = this.data.dataChashingService.pages[id]
    if (currentPage.addtionalMetaTags && currentPage.addtionalMetaTags != null) {
      let temp = JSON.parse(currentPage.addtionalMetaTags)
      for (let i = 0; i < temp.length; i++) {
        const element = temp[i];
        if (element.property == culture) {
          return this.setNewRoute(
            !!this.settings.prefix &&
            this.settings.prefix !== " "? this.settings.prefix : '', element.content)
        }
      }
    }
    return this.setNewRoute(!!this.settings.prefix &&
      this.settings.prefix !== " "? this.settings.prefix : '', '');
  }

  public getCultureLinkedBlog(id, culture) {
    const currentPage = this.data.dataChashingService.blogs[id]
    if (currentPage.addtionalMetaTags && currentPage.addtionalMetaTags != null) {
      let temp = JSON.parse(currentPage.addtionalMetaTags)
      for (let i = 0; i < temp.length; i++) {
        const element = temp[i];
        if (element.property == culture) {
          return this.setNewRoute(this.settings.prefix || '', element.content)
        }
      }
    }
    return '/';
  }

  public setNewRoute(prefix, newRoute) {
    this.router.config = [];
    this.data.moduleService.site.HostName = prefix.replace("/", '');
    this.data.routerService.getRoute();
    return '/' + prefix + newRoute
  }

  public setsiteCss(Culture,oldCulture) {
    let css = JSON.parse(this.data.moduleService.site.css);
    const head = document.getElementsByTagName('head')[0];
    if (css[Culture]) {
      const oldCss = document.getElementsByTagName('style');
      for (let index = 0; index < oldCss.length; index++) {
        const element = oldCss[index];
        if (element.id.indexOf(oldCulture + '-style') !== -1) {
          head.removeChild(element);
          index = index - 1;
        }
      }
      const culture_css = document.createElement('style');
      culture_css.type = 'text/css';
      culture_css.id = Culture + '-style';
      culture_css.appendChild(document.createTextNode(css[this.settings.Culture]));
      head.appendChild(culture_css);
    }
  }



}

//#region old menu

/*
 import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EssentialService } from '../../services/essential.service';

declare const $: any;

@Component({
  selector: 'app-childs-menu',
  styleUrls: ['./menu.component.css'],

  template: `
  <li *ngFor="let menu of childs;let i=index" class="child-item-{{i}} {{menu.childs&&menu.childs.length ? 'dropdown-submenu':''}}  {{checkIfActive(menu)}}">

  <a *ngIf="menu.type === 1" href="{{menu.url}}" target="{{menu.url.includes('.pdf')||menu.url.includes('http')?'_blank':'_self'}}" class="dropdown-item"
      [style.color]="settings.child_text_color"
      aria-haspopup="true" aria-expanded="false" matTooltip="{{settings.tooltipmenu?menu.name:''}}">
      <i class="fa fa-{{menu.icon}}"></i> <span>{{menu.name}}</span>
  </a>

  <a *ngIf="menu.type ===2" (click)="navigateTo(menu.slug,menu.url)" class="dropdown-item"
      [style.color]="settings.child_text_color"
      aria-haspopup="true" aria-expanded="false" matTooltip="{{settings.tooltipmenu?menu.name:''}}">
      <i class="fa fa-{{menu.icon}}"></i> <span>{{menu.name}}</span>
  </a>


  <a *ngIf="menu.type === 4" [routerLink]="'/'+menu.slug" class="dropdown-item"
   [style.color]="settings.child_text_color"
     aria-haspopup="true" aria-expanded="false" matTooltip="{{settings.tooltipmenu?menu.name:''}}">
     <i class="fa fa-{{menu.icon}}"></i> <span>{{menu.name}}</span>
 </a>

 <a *ngIf="menu.type ===5"  class="{{menu.childs&&menu.childs.length ?'dropdown-toggle' : ''}} dropdown-item"
  [style.color]="settings.child_text_color" data-toggle="dropdown"
    aria-haspopup="true" aria-expanded="false" matTooltip="{{settings.tooltipmenu?menu.name:''}}">
    <i class="fa fa-{{menu.icon}}"></i> <span>{{menu.name}}</span>
</a>
<a *ngIf="menu.type === 6" [routerLink]="'/' +menu.slug "
class="nav-link {{settings.hoverStyle}}  {{settings.bold?'font-weight-bold':''}}{{settings.italic?'font-italic':''}} dropdown-item"
[style.color]="settings.child_text_color"
aria-haspopup="true" aria-expanded="false" matTooltip="{{settings.tooltipmenu?menu.name:''}}">
<i class="fa fa-{{menu.icon}}"></i> <span>{{menu.name}}</span>
</a>



   <ul [style.background]="settings.child_background_color" class="dropdown-menu menu-{{settings.id}}" *ngIf="menu.childs&&menu.childs.length" style="width: max-content;">
        <app-childs-menu class="childs-menu"   [settings]="settings" [childs]="menu.childs"></app-childs-menu>
    </ul>
  </li>
  `,
})

export class ChildsMenuComponent implements OnInit {
  @Input() public settings: any;
  @Input() public childs;
  @Input() public data: any;

  constructor(private router: Router, private route: ActivatedRoute) { }

  public ngOnInit() {
    this.settings.nav_background_color = this.settings.nav_background_color && this.settings.nav_background_color.charAt(0) === '#' ? this.settings.nav_background_color : this.getThemeColor(this.settings.nav_background_color);
    this.settings.nav_text_color = this.settings.nav_text_color && this.settings.nav_text_color.charAt(0) === '#' ? this.settings.nav_text_color : this.getThemeColor(this.settings.nav_text_color);
    this.settings.child_background_color = this.settings.child_background_color && this.settings.child_background_color.charAt(0) === '#' ? this.settings.child_background_color : this.getThemeColor(this.settings.child_background_color);
    this.settings.child_text_color = this.settings.child_text_color && this.settings.child_text_color.charAt(0) === '#' ? this.settings.child_text_color : this.getThemeColor(this.settings.child_text_color);
    if (this.settings.noToggle) {
      this.getResponsiveNavToggle();
    }
  }

  public checkIfActive(menu) {
    if (menu.type === 2 &&
      (menu.slug === this.route.data['value'].slug)) {
      return 'active';
    }
    if (menu.childs && menu.childs.length) {
      for (const m of menu.childs) {
        if (m.type === 2 && (this.router.routerState.snapshot.url.includes(m.slug) ||
          m.slug === this.route.data['value'].slug)) {
          return 'active';
        }
      }
    }
    return '';
  }

  public getResponsiveNavToggle() {
    if (this.settings.minWidthToggle && this.settings.responsive) {
      const head = document.getElementsByTagName('head')[0];
      const style = document.createElement('style');
      const oldCss = document.getElementsByTagName('style');
      for (let index = 0; index < oldCss.length; index++) {
        const element = oldCss[index];
        if (element.id.indexOf('responsive-menu') !== -1) {
          head.removeChild(element);
          index = index - 1;
        }
      }
      style.id = 'responsive-menu';
      style.appendChild(document.createTextNode(this.settings.responsive));
      head.appendChild(style);
    }
  }

  public getThemeColor(color) {
    if (this.data && this.data.moduleService && this.data.moduleService.theme && this.data.moduleService.theme.colors) {
      return this.data.moduleService.theme.colors[color];
    } else {
      return 'initial';
    }
  }
  public navigateToSection(el) {
    const elmnt = document.getElementById(el);
    if (elmnt && elmnt != null) {
      elmnt.scrollIntoView();
    }

  }
  public navigateTo(slug, el) {
    if (!el) {
      this.router.navigate([slug]);
    }
    if (el && slug) {
      this.router.navigate([slug]);
      setTimeout(() => {
        const elmnt = document.getElementById(el);
        if (elmnt && elmnt != null) {
          elmnt.scrollIntoView();
        }
      }, 200);
    }

  }


}


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent implements OnInit, AfterViewInit {
  @Input() public settings: any;
  @Input() public data: any;

  public searchText: any;
  public menus: any[] = [];
  public site: any;
  public user: any;
  public activeClass = false;

  constructor(private router: Router, private route: ActivatedRoute, private essentialsService: EssentialService) { }

  public ngOnInit() {

    if (this.data.authService && this.data.authService.isLoggedIn()) {
      this.user = this.data.authService.getLoggedUser();
    }

    this.site = this.data.moduleService.site;
    this.GetCategoryMenus(this.settings.selectedCategory);
    this.settings.nav_background_color = this.settings.nav_background_color && this.settings.nav_background_color.charAt(0) === '#' ? this.settings.nav_background_color : this.getThemeColor(this.settings.nav_background_color);
    this.settings.nav_text_color = this.settings.nav_text_color && this.settings.nav_text_color.charAt(0) === '#' ? this.settings.nav_text_color : this.getThemeColor(this.settings.nav_text_color);
    this.settings.child_background_color = this.settings.child_background_color && this.settings.child_background_color.charAt(0) === '#' ? this.settings.child_background_color : this.getThemeColor(this.settings.child_background_color);
    this.settings.child_text_color = this.settings.child_text_color && this.settings.child_text_color.charAt(0) === '#' ? this.settings.child_text_color : this.getThemeColor(this.settings.child_text_color);



  }

  ngAfterViewInit(){
    this.route.params.subscribe(
      () => setTimeout(() => { this.GetCategoryMenus(this.settings.selectedCategory) }, 0)
    )
  }

  public checkIfActive(menu) {
    if (menu.type === 2 &&
      (menu.slug === this.route.data['value'].slug)) {
      return 'active';
    }
    if (menu.childs && menu.childs.length) {
      for (const m of menu.childs) {
        if (m.type === 2 && (this.router.routerState.snapshot.url.includes(m.slug) || m.slug === this.route.data['value'].slug)) {
          return 'active';
        }
      }
    }
    return '';
  }

  public getThemeColor(color) {
    if (this.data.moduleService && this.data.moduleService.theme && this.data.moduleService.theme.colors) {
      return this.data.moduleService.theme.colors[color];
    } else {
      return 'initial';
    }
  }
  public logOut() {
    this.user = this.data.authService.loggeOut();
    location.reload();
    // location.href=
  }

  public GetCategoryMenus(id) {
    if (!id) {
      this.menus = [];
      return;
    }
    if (this.data.dataChashingService && this.data.dataChashingService.menusCategories[id]) {
      this.menus = this.data.dataChashingService.menusCategories[id];
      this.sortMenu(this.menus);
      this.data.SharedService.setCurrentMenu(id);
      this.menus.forEach((element) => {
        if (element.childs.length > 0) {
          element.childs.forEach((child) => {
            const link = '/' + child.slug;

            if (link === this.router.url) {
              this.activeClass = true;

            }
          });
        }
      });
      setTimeout(() => {
        this.setJquryAndStyles();
      }, 500);
    } else {
      this.essentialsService.getCategoryMenus(id).subscribe((res: any) => {
        this.data.dataChashingService.menusCategories[id] = res;
        this.menus = res;
        this.sortMenu(this.menus);
        this.data.SharedService.setCurrentMenu(id);
        this.menus.forEach((element) => {
          if (element.childs.length > 0) {
            element.childs.forEach((child) => {
              const link = '/' + child.slug;

              if (link === this.router.url) {
                this.activeClass = true;

              }
            });
          }
        });
        setTimeout(() => {
          this.setJquryAndStyles();
        }, 500);
      });
    }
  }

  public sortMenu(menuItems) {
    menuItems.sort((a, b) => {
      return a.order - b.order;
    });
    menuItems.forEach((element) => {
      if (element.childs.length > 1) {
        this.sortMenu(element.childs);
      }
    });
  }



  public navigateToSection(el) {
    const elmnt = document.getElementById(el);
    if (elmnt && elmnt != null) {
      elmnt.scrollIntoView();
    }
  }

  public navigateTo(slug, el) {
    if (!el) {
      this.router.navigate([slug]);
    }
    if (el && slug) {
      this.router.navigate([slug]);
      setTimeout(() => {
        const elmnt = document.getElementById(el);
        if (elmnt && elmnt != null) {
          elmnt.scrollIntoView();
        }
      }, 200);
    }
  }

  public setJquryAndStyles() {
    this.setBordersAndShadow();
    const settings = this.settings;
    $('ul.dropdown-menu.menu-' + settings.id + ' [data-toggle=\'dropdown\']').on('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      let directionLeft = false;
      let opend = 'opend';

      if ($(this).offset().left > 1000) {
        directionLeft = true;
        opend = 'opend-left';
      }

      if ($(this).hasClass(opend)) {
        $(this).removeClass(opend);
      } else {
        $(this).toggleClass(opend);
      }

      if (directionLeft) {
        if ($(this).siblings().hasClass('left')) {
          $(this).siblings().removeClass('left');
        }
        $(this).siblings().toggleClass('left');
      }

      $(this).siblings().toggleClass('show');

      $(this).siblings().toggleClass(opend);

      if (!$(this).next().hasClass('show')) {
        $(this).parents('.dropdown-menu.menu-' + settings.id).first().find('.show').removeClass('show');
        $(this).parents('.dropdown-menu.menu-' + settings.id).first().find('.left').removeClass('left');
        $(this).parents('.dropdown-menu.menu-' + settings.id).first().find('.' + opend).removeClass(opend);
      }

      $(this).parents('li.nav-item.dropdown.' + 'show').on('hidden.bs.dropdown', () => {
        $('.dropdown-submenu .show').removeClass('show');
        $('.dropdown-submenu .show.left').removeClass('left');
        $('.dropdown-submenu .' + opend).removeClass(opend);

      });

    });

  }

  public setBordersAndShadow() {

    const nav = $('#nav-' + this.settings.id);
    if (this.settings.borderAll) {
      nav.css('border', this.settings.bordersize + 'px ' + this.settings.borderType + ' ' + this.settings.bordercolor);
    } else {
      if (this.settings.borderTop) {
        nav.css('border-top', this.settings.borderTop + 'px ' + this.settings.borderType + ' ' + this.settings.bordercolor);
      }
      if (this.settings.borderTop) {
        nav.css('border-bottom', this.settings.borderBottom + 'px ' + this.settings.borderType + ' ' + this.settings.bordercolor);
      }
      if (this.settings.borderTop) {
        nav.css('border-left', this.settings.borderLeft + 'px ' + this.settings.borderType + ' ' + this.settings.bordercolor);
      }
      if (this.settings.borderTop) {
        nav.css('border-right', this.settings.borderRight + 'px ' + this.settings.borderType + ' ' + this.settings.bordercolor);
      }

    }

    nav.css('box-shadow', this.settings.hoffset + 'px ' + this.settings.voffset + 'px ' + this.settings.blur + 'px ' + this.settings.spread + 'px ' + this.settings.boxcolor);

  }






  public navigateToCulture() {
    let link = ''
    //Customer portal
    let cpProductOutput: any = localStorage.getItem('cpProductOutput')
    if (this.route.data['value'].type == 1)
      link = this.getCultureLinkedPage(this.route.data['value'].id, this.settings.Culture);
    else
      link = this.getCultureLinkedBlog(this.route.data['value'].id, this.settings.Culture);

    if (link != '/' && this.data.moduleService.site.css) {
      this.setsiteCss(this.settings.Culture)
      this.data.moduleService.site.culture = this.settings.Culture;
      this.router.navigate([link]);
    }else{
      this.router.navigate([link]);
    }


    if (cpProductOutput) {
      cpProductOutput = JSON.parse(cpProductOutput)
        link = link + `/productpreview?step=${cpProductOutput.step}&userPropertiesId=${cpProductOutput.userPropertiesId}`
        localStorage.removeItem('cpProductOutput')  //cpProductOutput
        this.router.navigate([link]);
    }

  }


  public getCultureLinkedPage(id, culture) {
    const currentPage = this.data.dataChashingService.pages[id]
    if (currentPage.addtionalMetaTags && currentPage.addtionalMetaTags != null) {
      let temp = JSON.parse(currentPage.addtionalMetaTags)
      for (let i = 0; i < temp.length; i++) {
        const element = temp[i];
        if (element.property == culture) {
          return this.setNewRoute(this.settings.prefix || '', element.content)
        }
      }
    }
    return this.setNewRoute(this.settings.prefix || '', '');
  }


  public getCultureLinkedBlog(id, culture) {
    const currentPage = this.data.dataChashingService.blogs[id]
    if (currentPage.addtionalMetaTags && currentPage.addtionalMetaTags != null) {
      let temp = JSON.parse(currentPage.addtionalMetaTags)
      for (let i = 0; i < temp.length; i++) {
        const element = temp[i];
        if (element.property == culture) {
          return this.setNewRoute(this.settings.prefix || '', element.content)
        }
      }
    }
    return '/';
  }


  public setNewRoute(prefix, newRoute) {
    this.router.config = [];
    this.data.moduleService.site.HostName = prefix.replace("/", '');
    this.data.routerService.getRoute();
    return '/' + prefix + newRoute
  }


  public setsiteCss(Culture) {
    let css = JSON.parse(this.data.moduleService.site.css);
    const head = document.getElementsByTagName('head')[0];
    if (css[Culture]) {
      const oldCss = document.getElementsByTagName('style');
      for (let index = 0; index < oldCss.length; index++) {
        const element = oldCss[index];
        if (element.id.indexOf(this.data.moduleService.site.culture + '-style') !== -1) {
          head.removeChild(element);
          index = index - 1;
        }
      }
      const culture_css = document.createElement('style');
      culture_css.type = 'text/css';
      culture_css.id = Culture + '-style';
      culture_css.appendChild(document.createTextNode(css[this.settings.Culture]));
      head.appendChild(culture_css);
    }
  }








}
 */
//#endregion
